<template>
    <div class="content-item">
      <div class="content-header">
        <h4>{{ item.title }}</h4>
        <span class="content-source">{{ item.source }}</span>
      </div>
      <div class="content-body">
        <img v-if="item.image" :src="item.image" alt="Found image" class="content-image" />
        <div v-if="item.aiContent" class="ai-content">
          <h5>AI Generated Content:</h5>
          <p class="content-text">{{ item.aiContent }}</p>
        </div>
        <p class="content-text" :class="{ 'original-content': item.aiContent }">
          <span v-if="item.aiContent">Original Content:</span>
          {{ item.text }}
        </p>
      </div>
      <div class="content-actions">
        <button @click="postToTelegram" class="btn btn-sm">Post to Telegram</button>
        <button v-if="useAI && !item.aiContent" @click="generateAI" class="btn btn-sm btn-secondary">Generate AI Content</button>
        <button @click="removeItem" class="btn btn-sm btn-outline">Remove</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ContentItem',
    props: {
      item: {
        type: Object,
        required: true
      },
      useAI: {
        type: Boolean,
        default: false
      }
    },
    emits: ['post-to-telegram', 'generate-ai', 'remove'],
    methods: {
      postToTelegram() {
        this.$emit('post-to-telegram', this.item);
      },
      generateAI() {
        this.$emit('generate-ai', this.item);
      },
      removeItem() {
        this.$emit('remove', this.item);
      }
    }
  }
  </script>
  
  <style scoped>
  .content-item {
    border: 1px solid var(--border-color);
    border-radius: 8px;
    overflow: hidden;
  }
  
  .content-header {
    padding: 15px;
    border-bottom: 1px solid var(--border-color);
    background-color: #f9f9f9;
  }
  
  .content-source {
    font-size: 12px;
    color: var(--text-light);
  }
  
  .content-body {
    padding: 15px;
  }
  
  .content-image {
    width: 100%;
    height: 150px;
    object-fit: cover;
    margin-bottom: 10px;
    border-radius: 4px;
  }
  
  .content-text {
    font-size: 14px;
    color: var(--text-color);
    max-height: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .original-content {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px dashed var(--border-color);
    color: var(--text-light);
    font-size: 12px;
  }
  
  .ai-content {
    margin-bottom: 15px;
    padding: 10px;
    background-color: #f0f7ff;
    border-radius: 4px;
    border-left: 3px solid var(--secondary-color);
  }
  
  .ai-content h5 {
    color: var(--secondary-color);
    margin-bottom: 5px;
  }
  
  .content-actions {
    padding: 10px 15px;
    border-top: 1px solid var(--border-color);
    display: flex;
    justify-content: space-between;
  }
  </style>